import React, { Component } from 'react';

import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import SFSlider from '../../components/SFSlider';
import ContactFormTools from '../../components/ContactFormTools';

class CommuteCalculatorTool extends Component {

    state = {
        minutesCommutingPerDay: 60,
        daysCommutingPerWeek: 5,
        sumCalculatedTo: "week",
        canContact: true,
        email: "",
        name: "",
        id: 1,
        localId: ""
    }

    constructor() {
        super()
    }

    componentDidMount() {
        let localId = localStorage.getItem("localId");
        if (!localId) {
            const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
            localId = uint32.toString(16)
            localStorage.setItem("localId", localId);
        }
        this.setState({ localId })
    }

    generateResults() {
        if(this.state.sumCalculatedTo != "" && this.state.minutesCommutingPerDay != 0 && this.state.daysCommutingPerWeek != 0) {
            let multiplier
            switch (this.state.sumCalculatedTo) {
                case "week":
                    multiplier = 1
                    break;
                case "month":
                    multiplier = 4.35
                    break;
                case "year":
                    multiplier = 50
                    break;
                default:
                    multiplier = 1
                    break;
            }
            let totalMinutesCommuting = this.state.minutesCommutingPerDay * this.state.daysCommutingPerWeek * multiplier
            let totalMinutesInPeriod = 8 * 60 * 7 * multiplier
            let percentage = Math.ceil(totalMinutesCommuting / totalMinutesInPeriod * 100)
            let hours = Math.floor(totalMinutesCommuting / 60)
            let minutes = Math.floor(totalMinutesCommuting % 60)
            return (
                <div>
                    <br />
                    <text><i>Calculated for a {multiplier}-week period. Everyone takes a couple of weeks off, right?</i></text>
                    <br />
                    <text>
                        I spend 
                        <text style={{fontSize: 24}}> {hours} </text>
                        hours {minutes > 0 ? "and ": null}
                        <text style={{fontSize: 24}}> {minutes > 0 ? minutes : null}</text>
                        {minutes > 0 ? " minutes" : null} on the road every {this.state.sumCalculatedTo}!!
                    </text>                        
                    <br />
                    <div class="progress" style={{border: "1px solid #d01a62", backgroundColor: "#fff", borderRadius: "10px", height: "18px"}}>
                        <div class="progress-bar" role="progressbar" style={{width: percentage.toString() + "%", backgroundColor: "#d01a62"}} aria-valuenow={percentage.toString()} aria-valuemin="0" aria-valuemax="100">
                            <text>{percentage}%</text>
                        </div>
                    </div>
                    <text>
                        That's 
                        <text style={{fontSize: 24}}> {percentage}% </text>
                        of my free time in a {this.state.sumCalculatedTo}... <i>Given that sleep, work, and free time are 8 hours a day each.</i>
                    </text>  
                    <br />
                </div>
            )
        } else {
            return null
        }
    }

    render() {
        return (
            <div>
                <h1><i className="fa fa-calculator" style={{ color: "#d01a62" }}></i> Really, how much is my commute?</h1>
                <br />
                <Typography id="description_minutes" gutterBottom>
                    My daily commute (both ways) is:
                </Typography>
                <Typography id="minutes_title" gutterBottom>
                    {Math.floor(this.state.minutesCommutingPerDay / 60)} hours {this.state.minutesCommutingPerDay % 60} minutes
                </Typography>
                <SFSlider
                    defaultValue={60}
                    valueLabelDisplay="off"
                    color={"rgb(208, 26, 98)"}
                    marks={[
                        {
                          value: 0,
                          label: "0",
                        },
                        {
                          value: 720,
                          label: "12",
                        },
                        {
                          value: 1440,
                          label: "24",
                        },
                    ]}
                    min={0} max={1440}
                    value={this.state.minutesCommutingPerDay} 
                    onChange={(e, v) => this.setState({ minutesCommutingPerDay: v })}
                />

                <br />

                <Typography id="description_days" gutterBottom>
                    Days I commute in a regular week:
                </Typography>
                <Typography id="days_title" gutterBottom>
                    {this.state.daysCommutingPerWeek} days
                </Typography>
                <SFSlider
                    defaultValue={5}
                    valueLabelDisplay="off"
                    marks={[
                        {
                          value: 1,
                          label: "1",
                        },
                        {
                          value: 7,
                          label: "7",
                        },
                    ]}
                    min={1} max={7}
                    value={this.state.daysCommutingPerWeek} 
                    onChange={(e, v) => this.setState({ daysCommutingPerWeek: v })}
                />

                <Typography id="description_period" gutterBottom>
                    I want to see the results for a:
                </Typography>
                <Select
                    id="dropdownMenuButton"
                    value={this.state.sumCalculatedTo}
                    onChange={(e) => {this.setState({sumCalculatedTo: e.target.value})}}
                    >
                    <MenuItem value={"week"}>week</MenuItem>
                    <MenuItem value={"month"}>month</MenuItem>
                    <MenuItem value={"year"}>year</MenuItem>
                </Select>

                {this.generateResults()}
                
                <br />
                <ContactFormTools />
                
            </div>
        )
    }
}

export default CommuteCalculatorTool;